import { UserRole } from "shared-components";

export const ROLES_WITH_STORE_ACCESS = [
  UserRole.STORE_ADMIN,
  UserRole.STORE_STAFF,
  UserRole.DASH_ADMIN,
  UserRole.DASH_ANALYST,
  UserRole.DASH_STAFF,
];
